module.exports = __webpack_public_path__ + "static/media/frog(11).f12a067c.PNG";